// ══════════════════════════════════════════════════════════════
// COMPASS – Country Actions
// ══════════════════════════════════════════════════════════════
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { CountryDto } from '../../api/models/country-dto';

export const CountryActions = createActionGroup({
  source: 'Country',
  events: {
    'Load Countries': emptyProps(),
    /** Fetch again even when loaded, e.g. after a language switch (names are localized by the backend). */
    'Reload Countries': emptyProps(),
    'Load Countries Success': props<{ countries: CountryDto[] }>(),
    'Load Countries Failure': props<{ error: string }>(),
  },
});
